export default __webpack_public_path__ + "static/media/logo-qubisa.731c7b4b.png";